export default "__VITE_ASSET__CXiGB5sE__"